import * as classnames from 'classnames';
import * as React from 'react';

import { IRouterSlot } from '../../../types/store/routerData';
import { ISlotItemPort, ISlotItemSupply } from '../../../types/store/slotsItems';

export interface IModalItem {
  id: string;
  enabled: boolean;
  selected: boolean;
  item: ISlotItemPort | ISlotItemSupply;
}

interface IModalItemSelectProps {
  slotsItem: IModalItem;
  onClick: (slotRouterName: string, slotItemName: string) => void;
  routerSlot: IRouterSlot;
}

const ModalItemSelect: React.SFC<IModalItemSelectProps> = props => {
  const handleClick = (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    // tslint:disable-next-line:no-unused-expression
    props.slotsItem.enabled && props.onClick(props.routerSlot.name, props.slotsItem.id);
  };

  return (
    <button
      onClick={handleClick}
      className={classnames('drag-element', {
        'disabled-element': !props.slotsItem.enabled,
        'selected-element': props.slotsItem.selected
      })}
    >
      <img src={props.slotsItem.item.imageUrl} alt="" style={{ marginBottom: 16 }} />
      <h5>{props.slotsItem.item.name}</h5>
      <h6>{props.slotsItem.item.model}</h6>
    </button>
  );
};

interface IModalItemsInfoProps {
  routerSlot: IRouterSlot;
  allSlotsItems: IModalItem[];
  onClick: (slotRouterName: string, slotItemName: string) => void;
}
export const ModalItems: React.SFC<IModalItemsInfoProps> = props => (
  <div>
    <ul className="drag-element-list">
      {props.allSlotsItems.map(slotsItem => (
        <li key={`ModalItem-${slotsItem.id}`}>
          <ModalItemSelect slotsItem={slotsItem} onClick={props.onClick} routerSlot={props.routerSlot} />
        </li>
      ))}
    </ul>
    <div className="modal-actions">
      <button className="button" onClick={props.onClick.bind(undefined, props.routerSlot.name, undefined)}>
        Clear Slot
      </button>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Configurator/ModalConfigurator/ModalItems.tsx